import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export const NotificationBell = ({ data, reload, id = "notif" }) => {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const toggle = async () => {
    const o = !open; setOpen(o);
    if (!o && data.unread) { await api.post("/notifications/read").catch(() => {}); reload(); }
  };
  return (
    <div className="relative">
      <button data-testid={`${id}-bell`} onClick={toggle} className="relative p-2 rounded-lg hover:bg-slate-800/60 text-slate-300">
        <Bell className="w-5 h-5" />
        {data.unread > 0 && <span data-testid={`${id}-count`} className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">{data.unread > 99 ? "99+" : data.unread}</span>}
      </button>
      {open && (
        <div data-testid={`${id}-panel`} className="fixed z-50 left-3 right-3 bottom-20 sm:left-4 sm:right-auto sm:w-96 max-h-[60vh] overflow-y-auto bg-white text-slate-800 rounded-xl shadow-2xl border border-slate-200">
          <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
            <span className="font-semibold text-sm">Notifikasi</span>
            <button onClick={toggle} className="text-xs text-slate-400 hover:text-slate-700">Tutup</button>
          </div>
          {data.items.length === 0 && <div className="p-6 text-center text-sm text-slate-400">Belum ada notifikasi</div>}
          {data.items.map((n) => (
            <button key={n.id} data-testid={`${id}-item-${n.id}`} onClick={() => { toggle(); if (n.link) nav(n.link); }}
              className={`w-full text-left px-4 py-3 border-b border-slate-50 hover:bg-slate-50 ${n.read ? "" : "bg-amber-50/60"}`}>
              <div className="text-sm font-medium">{n.title}</div>
              <div className="text-xs text-slate-500 mt-0.5">{n.body}</div>
              <div className="text-[10px] font-mono text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
